import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { debug_log } from '../../Util/Util';

const SE = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const { formFields, form_component, se_count, children } = props;
	const { num_se } = formFields;

	const curStep = useSelector(state => state.curStep);
	const curFv = useSelector(state => state.fv);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData?.controller;
	const preview = pageData?.preview;
	const isPreview = preview === true || preview === '1' || preview === 1;
	const containerRef = useRef(null);

	const div_class = se_count === curStep ? 'js-step js-step-active fixtop' : 'js-step fixtop';
	//console.log(`children`, children);

	useEffect(() => {
		initFv();
	}, [curStep]);

	function initFv() {
		debug_log("initFv, se_count", se_count, `curStep`, curStep);
		if (isPreview) {
			debug_log('Preview mode, skipping FormValidation creation in SE');
			return;
		}
		// Skip FormValidation creation for Shopcarts controller
		if (controller && controller.includes('Shopcarts')) {
			debug_log('Shopcarts controller detected in SE component, skipping FormValidation creation');
			return;
		}
		if (typeof FormValidation === 'undefined') {
			debug_log('FormValidation not loaded, skipping SE initFv');
			return;
		}
		if (se_count === curStep) {
			if (curFv) {
				curFv.destroy();
				//console.log(`curFv destroyed`);
			}

			const fv = FormValidation.formValidation(
				document.getElementById(`step${se_count}`),
				{
				plugins: {
					trigger: new FormValidation.plugins.Trigger(),
					bootstrap: new FormValidation.plugins.Bootstrap5({
						rowSelector: '.form-group',
						eleInvalidClass: '',
						eleValidClass: ''
					}),
					autoFocus: new FormValidation.plugins.AutoFocus(),
					declarative: new FormValidation.plugins.Declarative({
						html5Input: true
					}),
				}
			});

			dispatch({type: 'SET_FV', payload: fv});
		} else if (curFv) {
			curFv.destroy();
			//console.log(`curFv destroyed`);
		}
	}

	return (
		<div id={`step${se_count}`} className={div_class}>
			<div className={`quest_list fixtop tab-on`}>
				{formFields.num_se > 1 && (
					<>
					<p className="guide">{form_component.label}</p>
					{form_component.content && (
						<div className="xt_area section_desc" dangerouslySetInnerHTML={{ __html: form_component.content }} />
					)}
					</>
				)}
				{children}
			</div>
		</div>
	);
}

export default SE;